import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { MarketplaceAddCashbackTransactionDocument } from '..';
export function useMarketplaceAddCashbackTransaction() {
  const [marketplaceAddCashbackTransaction] = useMutation(MarketplaceAddCashbackTransactionDocument, {
    context: {
      version: 2
    }
  });
  return useCallback(async (cashbackProvider, transactionId) => {
    await marketplaceAddCashbackTransaction({
      variables: {
        cashbackProvider,
        transactionId
      }
    });
  }, [marketplaceAddCashbackTransaction]);
}